
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MixingDetailsGrid extends Serenity.EntityGrid<MixingDetailsRow, any> {
        protected getColumnsKey() { return 'Inventory.MixingDetails'; }
        protected getDialogType() { return MixingDetailsDialog; }
        protected getIdProperty() { return MixingDetailsRow.idProperty; }
        protected getInsertPermission() { return MixingDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return MixingDetailsRow.localTextPrefix; }
        protected getService() { return MixingDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}